import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { useEmailActivation } from '../../../../entities/auth/hooks/auth.hooks'

export const ActivateEmail = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const { mutateAsync: activateUserByEmail } = useEmailActivation()
  const token = searchParams.get('token')

  useEffect(() => {
    if (token) {
      activateUserByEmail(token)
        .then((result) => {
          if (result.status === 'success') {
            toast.success('Аккаунт активирован')
            navigate('/')
          } else {
            toast.error('Ошибка активации аккаунта')
            navigate('/auth/register')
          }
        })
        .catch(() => toast.error('Ошибка активации аккаунта'))
    }
  }, [token])

  return <div className="d-flex justify-content-center align-items-center">{t('auth.register.emailIfActivating')}</div>
}
